import { Observable } from 'rxjs';
import { Group, GroupCreateData } from './group';

export abstract class GroupRepository {
  abstract getByDispositifId(dispositifId: number): Observable<Group[]>;
  abstract create(data: GroupCreateData): Observable<Group>;
  abstract update(id: number, data: GroupCreateData): Observable<Group>;
  abstract delete(id: number): Observable<void>;
}
